import { Me } from "api/adminAuthApi";
import { createContext, Dispatch } from "react";
import { ActionMap } from "store/ActionMap";

type InitialStateType = {
  me: Me;
  loaded: boolean;
};

export const authInitialState = {
  me: {} as Me,
  loaded: false,
};

export const AuthContext = createContext<{
  state: InitialStateType;
  dispatch: Dispatch<Actions>;
}>({
  state: authInitialState,
  dispatch: () => null,
});

export enum AuthActionTypes {
  SetUser = "SET_USER",
}

type Payload = {
  [AuthActionTypes.SetUser]: Me;
};

export type Actions = ActionMap<Payload>[keyof ActionMap<Payload>];

export const authReducer = (state: InitialStateType, action: Actions): InitialStateType => {
  switch (action.type) {
    case AuthActionTypes.SetUser:
      return { ...state, me: action.payload, loaded: true };

    default:
      return state;
  }
};
